export const tr = {
    fatalError: 'Kopyalama sırasında hata oluştu. Lütfen, az sonra tekrar deneyin'
};
